export default "__VITE_ASSET__4c622953__"